import * as tslib_1 from "tslib";
import { lazyGetAllFileProviders } from 'owa-fileprovider-store';
import { action } from 'satcheljs/lib/legacy';
var isInitialized = false;
export default action('initializeStorageAccountsOption')(function initializeStorageAccountsOption() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!isInitialized) return [3 /*break*/, 2];
                    return [4 /*yield*/, lazyGetAllFileProviders.import()];
                case 1:
                    // Get the all file providers
                    (_a.sent())();
                    isInitialized = true;
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=initializeStorageAccountsOption.js.map